<template>
  <b-card title="Posnet Yapılandırması">
    <b-form-group
      label="Posnet ID (Client ID, PID)"
      label-for="posnet_client_id"
    >
      <b-form-input
        id="posnet_client_id"
        v-model="posnet_client_id"
        placeholder="Posnet ID (Client ID, PID)"
      />
    </b-form-group>
    <b-form-group
      label="Terminal ID (TID)"
      label-for="posnet_terminal_id"
    >
      <b-form-input
        id="posnet_terminal_id"
        v-model="posnet_terminal_id"
        placeholder="Terminal ID (TID)"
      />
    </b-form-group>
    <b-form-group
      label="Merchant ID (MID)"
      label-for="posnet_merchant_id"
    >
      <b-form-input
        id="posnet_merchant_id"
        v-model="posnet_merchant_id"
        placeholder="Merchant ID (MID)"
      />
    </b-form-group>
    <b-form-group
      label="Şifreleme Anahtarı (EncKey)"
      label-for="posnet_encKey"
    >
      <b-form-input
        id="posnet_encKey"
        v-model="posnet_encKey"
        placeholder="Şifreleme Anahtarı (EncKey)"
      />
    </b-form-group>
    <b-form-group
      label="Doğrudan Ödeme Bağlantısı (Api-Classic URL)"
      label-for="posnet_api_url"
    >
      <b-form-input
        id="posnet_api_url"
        v-model="posnet_api_url"
        placeholder="Doğrudan Ödeme Bağlantısı (Api-Classic URL)"
      />
    </b-form-group>
    <b-form-group
      label="3D Bağlantısı (3D, 3DGate URL)"
      label-for="posnet_3d_url"
    >
      <b-form-input
        id="posnet_3d_url"
        v-model="posnet_3d_url"
        placeholder="3D Bağlantısı (3D, 3DGate URL)"
      />
    </b-form-group>
  </b-card>
</template>
<script>
import { BCard, BFormGroup, BFormInput } from 'bootstrap-vue'
import { configField } from '@/views/PosConfigs/Configs/configBind'

export default {
  name: 'Posnet',
  components: {
    BCard,
    BFormGroup,
    BFormInput,
  },
  computed: {
    posConfig() {
      return this.$store.getters['posConfigs/getPos_config']
    },
    posnet_client_id: configField('posnet_client_id'),
    posnet_terminal_id: configField('posnet_terminal_id'),
    posnet_merchant_id: configField('posnet_merchant_id'),
    posnet_encKey: configField('posnet_encKey'),
    posnet_api_url: configField('posnet_api_url'),
    posnet_3d_url: configField('posnet_3d_url'),
  },
}
</script>
<style scoped></style>
